<template>
    <div class="study-section" v-if="studyArr != null" id="menu-link-study">
        <div class="container">
            <sectionTitle :options="[{ title : studyArr.study_title}]"></sectionTitle>
            <sectionBaner :options="[{ bg: studyArr.study_quote_img, title : studyArr.study_quote_title, desc: studyArr.study_quote_desc}]"></sectionBaner>
            <sectionDescColumn :options="[{ desc_left : studyArr.study_desc_left, desc_right: studyArr.study_desc_right}]" class="section-desc-column-study"></sectionDescColumn>
            <sectionImagesMobile :options="[{ images: studyArr.study_images_mobile}]" v-if="isMobileGlobal"></sectionImagesMobile>
            <sectionImagesGrid :options="[{ cards: studyArr.study_cards.slice(0, 3), grid_img : studyArr.study_img}]" class="section-images-study"></sectionImagesGrid>
        </div>
    </div>
</template>

<script>
    import sectionTitle from '@/components/partials/section-title.vue'
    import sectionBaner from '@/components/partials/section-baner.vue'
    import sectionDescColumn from '@/components/partials/section-desc-column.vue'
    import sectionImagesGrid from '@/components/partials/section-images-grid.vue'
    import sectionImagesMobile from '@/components/partials/section-images-mobile.vue'
    import {mapGetters} from 'vuex'
    export default {
        name: 'street-retail-section',
        data () {
            return {
            }
        },
        computed: mapGetters({
            studyArr: 'loadStudyArr',
            isMobileGlobal: 'loadisMobileGlobal',
        }),
        components: {
            sectionTitle,
            sectionBaner,
            sectionDescColumn,
            sectionImagesGrid,
            sectionImagesMobile,
        },
        methods: {
        },
        mounted() {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/study/study-section.scss';
    @import '@/styles/components/study/study-section-respond.scss';
</style>